import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';

import PlaceDetails from '../PlaceDetails/PlaceDetails.jsx';

const List = ({ isLoading, distributor, childClicked, coordinates, setCoordinates }) => {
    const [getCity, setGetCity] = useState();
    const [getCounty, setGetCounty] = useState();
    const [getUsState, setGetUsState] = useState();

    function GetAddress() {
        var lat = coordinates.lat;
        var lng = coordinates.lng;
        var latlng = new google.maps.LatLng(lat, lng);
        var geocoder = geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                if (results[1]) {
                    const getResultLenght = results.length;

                    if (results.length === getResultLenght) {
                        const getCountyData = results[getResultLenght-3].formatted_address;
                        const getUsStateData = results[getResultLenght-2].formatted_address;
                        const getCityData = results[getResultLenght-4].formatted_address;
                        setGetCity(getCityData.split(', ',2));
                        setGetCounty(getCountyData.split(', ',2));
                        setGetUsState(getUsStateData.split(', ',2));
                    }
                    if (results.length <= 4) {
                        const getCountyData = results[3].formatted_address;
                        const getUsStateData = results[4].formatted_address;
                        const getCityData = results[2].formatted_address;
                        setGetCity(getCityData.split(', ',2));
                        setGetCounty(getCountyData.split(', ',2));
                        setGetUsState(getUsStateData.split(', ',2));
                    }
                }
            }
        });
    }

    useEffect(() => {
        GetAddress();
    }, [coordinates]);

    return (
        <>
        { distributor.length > 0 ? 
        <div className="distributor-finder-list-container" id="distributor-places">
            <div className="distributor-finder-legend-container">
                <div className="distributor-finder-legend-container-your-position">
                    <div className="your-position-color"></div>
                    <div className="your-position-text">{`${Drupal.t('Your search location')}`}</div>
                </div>
                <div className="distributor-finder-legend-container-prime-position">
                    <div className="prime-position-color"></div>
                    <div className="prime-position-text">{`${Drupal.t('Prime Distributor')}`}</div>
                </div>
                <div className="distributor-finder-legend-container-default-position">
                    <div className="default-position-color"></div>
                    <div className="default-position-text">{`${Drupal.t('Distributor')}`}</div>
                </div>
            </div>
            <div className="distributor-finder-list-container-title">
                <h4>{`${Drupal.t('BAUER Distributors Near You')}`}</h4>
            </div>
            {isLoading ? (
                <div className="distributor-finder-loading">
                    <CircularProgress size="5rem" />
                </div>
            ) : (
                <>
            <div className="distributor-places-container">
                {distributor?.map((place, i) => { 
                    const coverageId = place.field_distributor_coverage_id;

                    if(coverageId !== undefined) {
                        if(coverageId.includes(",")) {
                            var coverage = coverageId.split(', ');
                        } else {
                            coverage = [coverageId]
                        }
                    }

                    const foundCity = getCity.some(r=> coverage.indexOf(r) >= 0);
                    const foundCounty = getCounty.some(r=> coverage.indexOf(r) >= 0);
                    const foundUsState = getUsState.some(r=> coverage.indexOf(r) >= 0);

                    if (foundCounty === true || foundUsState === true || foundCity === true) {
                        return (
                            <div key={i} className={`distributor-places-box prime-distributor`}>
                                <PlaceDetails place={place} selected={Number(childClicked) === i} />
                            </div>
                        )
                    } else {
                        return (
                            <div key={i} className={`distributor-places-box default-distributor`}>
                                <PlaceDetails place={place} selected={Number(childClicked) === i} />
                            </div>
                        )
                    }  
                })}
            </div>
            </>
            )}
        </div> : 
            <></>
         }
        </>
    );
}

export default List;